// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1uEKh","empty":"ModalGraph_empty__HVqnf"};